import { render, staticRenderFns } from "./productpre.vue?vue&type=template&id=1d0337cc&"
import script from "./productpre.vue?vue&type=script&lang=js&"
export * from "./productpre.vue?vue&type=script&lang=js&"
import style0 from "./productpre.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports